import { createUseStyles as baseCreateUseStyles } from 'react-jss';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createUseStyles: typeof baseCreateUseStyles = (styles, options = {}) => baseCreateUseStyles(styles, {
  ...options,
  generateId: options.name ? (rule): string => `${options.name}-${rule.key}` : undefined,
});
